<template>
  <div id="btnAddProduct">
    <v-menu
      v-model="menu"
      offset-x
      attach="#btnAddProduct"
      :close-on-content-click="false"
      close-on-click
    >
      <template
        v-slot:activator="{ on}"
      >
        <v-btn
          small
          v-on="on"
        >
          Додати продукт
        </v-btn>
      </template>
      <v-card>
        <v-row dense>
          <v-col>
            <v-card-text>
              <ProductSelect
                v-model="selected"
                @input="onProductChange"
              />
              <v-row>
                <v-col>
                  <v-select
                    v-model="version"
                    :disabled="!productVersions"
                    :items="productVersions"
                    item-text="version"
                    hide-details
                    label="Версія"
                    clearable
                    dense
                    outlined
                  />
                </v-col>
                <v-col cols="4">
                  <v-switch
                    v-model="updateByClient"
                    :disabled="!product"
                    color="green"
                    label="Оновлюються самостійно"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <CustomTextField
                    v-model="regNumber"
                    :disabled="!product"
                    label="Регістраційний номер"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <CustomTextField
                    v-model="notes"
                    :disabled="!product"
                    label="Примітки"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                :disabled="!product"
                text
                @click="ok"
              >
                ОК
              </v-btn>
              <v-btn
                text
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ProductSelect from "@/views/catalogs/products/ProductSelect.vue";
import * as productsApi from "@/backend/productsApi.js";

export default {
  components: {
    ProductSelect,
  },
  data: () => ({
    menu: false,
    product: null,
    version: null,
    updateByClient: false,
    regNumber: "",
    notes: "",
    selected: null,
  }),
  computed: {
    productVersions() {
      return this.product
        ? [...this.product.productVersions]
          .sort(
            (a, b) => this.moment(b.releaseDate) - this.moment(a.releaseDate)
          )
          .map((pv) => pv.version)
        : null;
    },
  },
  methods: {
    async onProductChange(product) {
      if (product?.id) {
        this.product = await productsApi.getProduct(product.id);
      }
    },
    ok() {
      const clientProduct = {
        product: {
          id: this.product.id,
          actualVersion: this.product.actualVersion,
          productVersions: this.product.productVersions,
          title: this.product.title,
        },
        regNumber: this.regNumber,
        updateByClient: this.updateByClient,
        version: this.version,
        notes: this.notes,
        type: this.product.type,
        trackVersions: this.product.trackVersions,
      };
      this.$emit("input", clientProduct);
      this.cancel();
    },
    cancel() {
      this.menu = false;
      this.product = null;
      this.updateByClient = false;
      this.regNumber = "";
      this.version = "";
      this.notes = "";
      this.selected = null;
    },
  },
};
</script>
